export async function getCurrentPosition(): Promise<{
  lat: number;
  lon: number;
}> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported on this device"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
        });
      },
      (err) => {
        let errorMessage = "Could not get your location.";
        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorMessage =
              "Location access denied. Please enable location permissions in your browser settings.";
            break;
          case err.POSITION_UNAVAILABLE:
            errorMessage =
              "Location information is unavailable. Please check your GPS/network connection.";
            break;
          case err.TIMEOUT:
            errorMessage = "Location request timed out. Please try again.";
            break;
          default:
            errorMessage =
              "An unknown error occurred while getting your location.";
        }
        reject(new Error(errorMessage));
      },
      {
        enableHighAccuracy: false, // Better for mobile compatibility and battery
        timeout: 15000, // Longer timeout for mobile networks
        maximumAge: 300000, // Allow cached position up to 5 minutes
      }
    );
  });
}
